import { useEffect } from 'react'

import api, { TApiError, TEntity } from 'src/utils/api'
import Loadable, { TLoadable } from 'src/utils/Loadable'
import { IAgentActivityReport, IAgent } from '@obvious.tech/constellation'
import { getAgentByPassportId } from 'src/utils/api/getAgentByPassportId'

export type TProps = {
  agentActivityReport: TEntity<IAgentActivityReport>
  authorization?: string
}

export type TUseAgentActivityReportAgentResult = TLoadable<
  TEntity<IAgent>,
  TApiError
>

const useAgentActivityReportAgent = ({
  agentActivityReport,
  authorization,
}: TProps): TUseAgentActivityReportAgentResult => {
  const [agent, getAgent] = api.useApiAction(getAgentByPassportId)
  const passportId = agentActivityReport.author?.passportId

  useEffect(() => {
    if (typeof passportId !== 'string') return
    return getAgent({
      passportId,
      token: authorization,
    })
  }, [passportId, authorization, getAgent])

  if (typeof passportId !== 'string')
    return Loadable.failure(
      new Error(
        `Unable to retrieve Agent from passportId (${JSON.stringify(
          passportId,
        )})`,
      ),
    )

  return agent
}

export default useAgentActivityReportAgent
